import i18n from 'i18next'

import { IDirectionDetail } from 'entities/ticket/ui/direction-detail'
import { FlyItem } from 'entities/ticket/ui/direction-detail/types.ts'

export const getBaggageWarning = (directions?: IDirectionDetail[]) => {
  if (!directions?.length) return null

  const hasNoBaggage = (item: FlyItem) => {
    const baggage = item?.baggageInfo?.baggage
    return !baggage?.weight && !baggage?.piece
  }

  const firstDirection = directions.at(0)
  const lastDirection = directions.at(-1)

  const hasNoBaggageThere = firstDirection?.flyItems?.some(hasNoBaggage)
  const hasNoBaggageBack = lastDirection?.flyItems?.some(hasNoBaggage)

  if (hasNoBaggageThere) {
    return i18n.t('tickets_page.outbound_no_bag')
  }

  if (hasNoBaggageBack && directions.length > 1) {
    return i18n.t('tickets_page.return_no_bag')
  }

  return null
}
